import { useState } from "react"
import Header from "../Header/Header"
import LeftNavBar from "../LeftNavBar/LeftNavBar"
import { Outlet} from "react-router-dom"




export default function AdminLayout({ children }) {
   

  const [sidebarCollapsed, setSidebarCollapsed] = useState(true)

  const toggleMenu = () => {
    setSidebarCollapsed(!sidebarCollapsed)
  }

  

  return (
    <div className="admin-layout" >
      <LeftNavBar isCollapsed={sidebarCollapsed} />
      <main className={`main-content ${sidebarCollapsed ? "sidebar-collapsed" : ""}`}>
        <Header menuToggleHandler={toggleMenu} />
        <Outlet/>
      </main>
    </div>
  )
}
